import { useQueryClient } from "@tanstack/react-query";
import log from "logbeacon";

import { useState } from "react";
import { OspToast } from "@ospweb/sdk-ui";
import { QUERY_KEYS } from "../config";
import { BindTypeEnum } from "../features";
import { EdgenModalCreateAble } from "../components/EdgenModal";
import { useOspApiClientProvider } from "./useOspApiClientProvider";

/**
 * 获取绑定信息的 hook
 */
export const useSingleBind = (props: { type: BindTypeEnum }) => {
  const { openApi } = useOspApiClientProvider();
  const queryClient = useQueryClient();
  const [isLoading, setLoading] = useState(false);
  const { type } = props;

  const unBind = async (params?: any) => {
    setLoading(true);
    const unBindRes = await openApi?.bind.unbind(type, params);

    setLoading(false);
    if (!unBindRes?.data?.data) {
      OspToast.success({
        content: "Operation failed, please try again",
      });
      return;
    }
    setTimeout(() => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.CREDENTIAL_CUSTOM_ME],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.GET_BIND_LIST],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.GET_BIND],
      });
      EdgenModalCreateAble.end(false);
      OspToast.success({
        content: "Operation successful",
      });
    }, 1000);
  };

  const bind = async (params?: any) => {
    try {
      setLoading(true);
      const response = await openApi?.bind.bind(type, params);
      return {
        data: response?.data?.data,
        error: null,
      };
    } catch (err: any) {
      const Error = err.error;
      log.error(
        "[Bind] account ==== useBindAccount error:",
        type,
        JSON.stringify(Error),
      );
      setLoading(false);
      return {
        data: null,
        error: {
          code: Error?.code,
          msg: Error?.msg,
          data: Error?.data,
        },
      };
    }
  };

  return {
    unBind,
    bind,
    isLoading,
  };
};
